import type { Benefit } from '../../../../types/ClubCard/ClubCardBenefits'

export function benefitsListMapper(list?: Benefit[]) {
  return list?.map((item) => item?.benefit) ?? []
}
